import { Navigate, useLocation } from 'react-router-dom'
import type { ReactElement } from 'react'
import { useAuthStore } from '@core/auth/auth.store'
import {LoadingComponent} from '@shared/components/loading/loading'

export const RequireAuth = ({ children }: { children: ReactElement }) => {
  const { isAuthenticated, isLoading, reasonCancellation } = useAuthStore()
  const location = useLocation()

  console.log("RequireAuth")
  console.log("reasonCancellation", reasonCancellation);
  console.log("isAuthenticated", isAuthenticated);
  console.log("isLoading", isLoading);
  
  if (isLoading) return <LoadingComponent />

  if (isAuthenticated) {
    return children
  }

  if (reasonCancellation === 'SESSION_EXPIRED' || reasonCancellation === 'LINK_EXPIRED' ||
      reasonCancellation === 'TIME_EXPIRED' || reasonCancellation === 'VITAL_SIGNS_COMPLETED'
  ) {
    return <Navigate to="/expiredlink" state={{ from: location }} replace />
  }

  if (reasonCancellation === 'PLAN_NOT_ACTIVE') {
    return <Navigate to="/vitalsignslimit" state={{ from: location }} replace />
  }

  //-NOT AUTHENTICATED
  return <Navigate to="/sessionfinished" state={{ from: location }} replace />
 
}
